import { supabase } from "../../../supabaseClient";

export async function checkTeamsScoresComplete(teams) {
  if (!teams.length) return false;

  // Extract team IDs from team objects
  const teamIds = teams.map((team) => team.id);

  // Get team details with their events to check required scores
  const { data: teamDetails, error: teamError } = await supabase
    .from("teams")
    .select(
      `
      id,
      eventEntry (
        tournamentEvents (
          id,
          gamesPerEvent,
          bowlerQuantity
        )
      )
    `
    )
    .in("id", teamIds)
    .eq("isDeleted", false);

  if (teamError) throw teamError;

  // Get all scores for these teams
  const { data: scores, error: scoresError } = await supabase
    .from("scores")
    .select("teamID, bowlerID, gameNumber")
    .in("teamID", teamIds);

  if (scoresError) throw scoresError;

  // Group scores by team
  const teamScoreMap = new Map();
  scores.forEach((score) => {
    if (!teamScoreMap.has(score.teamID)) {
      teamScoreMap.set(score.teamID, []);
    }
    teamScoreMap.get(score.teamID).push(score);
  });

  // Check each team has all required scores
  return teamDetails.every((team) => {
    const teamScores = teamScoreMap.get(team.id) || [];

    // Skip teams that don't have event entries
    if (!team.eventEntry || team.eventEntry.length === 0) {
      return true;
    }

    // Check each event this team is registered for
    return team.eventEntry.every((entry) => {
      const event = entry.tournamentEvents;
      if (!event) {
        return true; // Skip if no event data
      }

      const gamesPerEvent = event.gamesPerEvent || 3; // Default to 3 games
      const bowlerQuantity = event.bowlerQuantity || 1; // Default to 1 bowler
      const requiredScores = gamesPerEvent * bowlerQuantity;

      // Count unique scores for this team (bowler + game combination)
      const uniqueScores = new Set();
      teamScores.forEach((score) => {
        uniqueScores.add(`${score.bowlerID}-${score.gameNumber}`);
      });

      const isComplete = uniqueScores.size >= requiredScores;

      return isComplete;
    });
  });
}
